/* Global cart handlers:
 *  (1) Product page add-to-cart - intercept the form submit, AJAX to
 *      /cart/add.js, show live's success message ("{title} has been
 *      successfully added to your cart. Feel free to Continue Shopping
 *      or check out.") instead of redirecting to /cart.
 *  (2) Cart page quantity / remove - in-place updates via Section
 *      Rendering API, no page reload.
 */
(function () {
  'use strict';

  function getCartCountEls() {
    return document.querySelectorAll('[data-header-cart-count]');
  }
  function updateHeaderCount(n) {
    getCartCountEls().forEach(function (el) {
      el.textContent = n > 0 ? n : '';
    });
  }

  // ---------- (1) Product page add-to-cart ----------

  function showProductMessage(form, productTitle) {
    // Live inserts the message INSIDE the .product-details__add-to-cart-area
    // wrapper, after the .surface-pick-up div. Find that wrapper on the
    // current form, or fall back to inserting after the form.
    var area = form.querySelector('.product-details__add-to-cart-area')
            || form.closest('.product-details__add-to-cart-area')
            || form.parentNode;
    var existing = area.querySelector('.product-message');
    if (existing) existing.remove();

    // Live markup VERBATIM:
    //   <div class="product-message">
    //     {title} has been successfully added to your <a href="/cart">cart</a>.
    //     Feel free to <a href="/collections/all">Continue Shopping</a> or
    //     <form class="product-message__form" action="/cart" method="POST">
    //       <button class="product-message__btn" type="submit" name="checkout">check out</button>
    //     </form>.
    //   </div>
    var msg = document.createElement('div');
    msg.className = 'product-message';
    msg.innerHTML =
      escapeHtml(productTitle) +
      ' has been successfully added to your <a href="/cart">cart</a>. ' +
      'Feel free to <a href="/collections/all">Continue Shopping</a> or ' +
      '<form class="product-message__form" action="/cart" method="POST">' +
        '<button class="product-message__btn" type="submit" name="checkout">check out</button>' +
      '</form>.';
    area.appendChild(msg);
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function setLoading(form, on) {
    // Live toggles the .product-details__add-to-cart-button--loading class
    // which hides [data-product-atc-text] and shows [data-product-atc-loader].
    var btn = form.querySelector('[data-product-atc]');
    if (!btn) return;
    btn.classList.toggle('product-details__add-to-cart-button--loading', !!on);
    btn.disabled = !!on;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches) return;
    // Only intercept product add-to-cart forms. Skip cart page form.
    if (!form.matches('form[action$="/cart/add"], form[action*="/cart/add?"]')) return;
    if (form.matches('form.cart-form, form[action$="/cart"]')) return;

    e.preventDefault();
    setLoading(form, true);
    var data = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (res) {
        return res.json().then(function (body) { return { ok: res.ok, body: body }; });
      })
      .then(function (result) {
        if (!result.ok) {
          var msg = (result.body && (result.body.description || result.body.message)) || 'Unable to add to cart';
          window.alert(msg);
          return;
        }
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateHeaderCount(cart.item_count);
            var title = (result.body && (result.body.product_title || result.body.title)) || 'Item';
            showProductMessage(form, title);
          });
      })
      .catch(function () { window.alert('Unable to add to cart'); })
      .finally(function () { setLoading(form, false); });
  }, true);

  // ---------- (2) Cart page in-place quantity / remove ----------

  function bindCartHandlers() {
    document.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
      if (input.dataset.cartBound) return;
      input.dataset.cartBound = '1';
      input.addEventListener('change', onQtyChange);
    });
    document.querySelectorAll('.cart-item__remove').forEach(function (link) {
      if (link.dataset.cartBound) return;
      link.dataset.cartBound = '1';
      link.addEventListener('click', onRemoveClick);
    });
  }

  function onQtyChange(e) {
    var input = e.currentTarget;
    var line = parseInt(input.dataset.cartLine, 10);
    var quantity = parseInt(input.value, 10) || 0;
    changeCart(line, quantity);
  }
  function onRemoveClick(e) {
    e.preventDefault();
    var link = e.currentTarget;
    var line = parseInt(link.dataset.cartLine, 10);
    changeCart(line, 0);
  }

  function changeCart(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateHeaderCount(cart.item_count);
        if (cart.item_count === 0) {
          // Need full re-render to switch to empty state markup.
          location.reload();
          return;
        }
        refreshSection();
      });
  }

  function refreshSection() {
    var sectionScript = document.querySelector('script[data-section-type="static-cart"]');
    var sectionId = sectionScript ? sectionScript.dataset.sectionId : null;
    if (!sectionId) { location.reload(); return; }

    fetch('/cart?section_id=' + encodeURIComponent(sectionId))
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var template = document.createElement('template');
        template.innerHTML = html.trim();
        var newSection = template.content.querySelector('section.cart');
        var currentSection = document.querySelector('section.cart');
        if (newSection && currentSection) {
          currentSection.replaceWith(newSection);
          bindCartHandlers();
        } else {
          location.reload();
        }
      })
      .catch(function () { location.reload(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCartHandlers);
  } else {
    bindCartHandlers();
  }
})();
